import { render } from "./querysystem.vue?vue&type=template&id=113743e2&scoped=true"
import script from "./querysystem.vue?vue&type=script&lang=js"
export * from "./querysystem.vue?vue&type=script&lang=js"

import "./querysystem.vue?vue&type=style&index=0&id=113743e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-113743e2"

export default script